import { SubscriptionSearchResult, AccountInfo, SearchState, initialSearchState, PartnerResult } from './store'
import { SELECT_PARTNER } from '../../auth/store/reducers'
import { RequestState } from '../../../modules/types'

export const SEARCH_SUBSCRIPTIONS_REQUEST = 'SEARCH_SUBSCRIPTIONS_REQUEST'
export const SEARCH_SUBSCRIPTIONS_RECEIVED = 'SEARCH_SUBSCRIPTIONS_RECEIVED'
export const SEARCH_SUBSCRIPTIONS_ERROR = 'SEARCH_SUBSCRIPTIONS_ERROR'
export const SEARCH_ACCOUNTS_REQUEST = 'SEARCH_ACCOUNTS_REQUEST'
export const SEARCH_ACCOUNTS_RECEIVED = 'SEARCH_ACCOUNTS_RECEIVED'
export const SEARCH_ACCOUNTS_ERROR = 'SEARCH_ACCOUNTS_ERROR'
export const SEARCH_TOGGLE_DEACTIVATED = 'SEARCH_TOGGLE_DEACTIVATED'
export const RESET_SEARCH = 'RESET_SEARCH'

export type SearchAction =
  | { type: typeof SEARCH_SUBSCRIPTIONS_REQUEST }
  | { type: typeof SEARCH_SUBSCRIPTIONS_RECEIVED, results: SubscriptionSearchResult[], timeStamp: number }
  | { type: typeof SEARCH_SUBSCRIPTIONS_ERROR }
  | { type: typeof SEARCH_ACCOUNTS_REQUEST }
  | { type: typeof SEARCH_ACCOUNTS_RECEIVED, results: AccountInfo[], partnerResults: PartnerResult[], timeStamp: number }
  | { type: typeof SEARCH_ACCOUNTS_ERROR }
  | { type: typeof SELECT_PARTNER }
  | { type: typeof RESET_SEARCH }
  | { type: typeof SEARCH_TOGGLE_DEACTIVATED, deactivated: boolean }

export function searchReducer(state: SearchState, action: SearchAction) {
  switch (action.type) {
    case SEARCH_SUBSCRIPTIONS_REQUEST: {
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          requestState: RequestState.Loading
        }
      }
    }

    case SEARCH_SUBSCRIPTIONS_RECEIVED: {
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          requestState: RequestState.Loaded,
          timeStamp: action.timeStamp,
          results: action.results
        }
      }
    }

    case SEARCH_SUBSCRIPTIONS_ERROR: {
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          requestState: RequestState.Error,
          results: []
        }
      }
    }

    case SEARCH_ACCOUNTS_REQUEST: {
      return {
        ...state,
        accounts: {
          ...state.accounts,
          requestState: RequestState.Loading
        }
      }
    }

    case SEARCH_ACCOUNTS_RECEIVED: {
      return {
        ...state,
        accounts: {
          ...state.accounts,
          requestState: RequestState.Loaded,
          timeStamp: action.timeStamp,
          results: action.results,
          otherPartnerResults: action.partnerResults
        }
      }
    }

    case SEARCH_ACCOUNTS_ERROR: {
      return {
        ...state,
        accounts: {
          ...state.accounts,
          requestState: RequestState.Error,
          results: [],
          otherPartnerResults: []
        }
      }
    }

    case SEARCH_TOGGLE_DEACTIVATED: {
      return {
        ...state,
        includeDeactivated: action.deactivated,
      }
    }

    case SELECT_PARTNER: {
      return {
        ...initialSearchState,
        includeDeactivated: state.includeDeactivated
      }
    }

    case RESET_SEARCH: {
      return {
        ...initialSearchState,
        includeDeactivated: state.includeDeactivated
      }
    }

    default: {
      return state
    }
  }
}
